/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import CloseIcon from '@mui/icons-material/esm/Close';
import Error from '@mui/icons-material/esm/Error';
import { red } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withUser } from '../../UserProvider';
import { DynamicFormattedMessage } from './DynamicFormattedMessage';

function ServiceStatusNotification({ service = 'Default-Service', status = 'connected' } = {}) {
	const [closed, setClosed] = useState(false);
	const onClose = () => setClosed(true);

	return (
		<Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={status === 'disconnected' && !closed}>
			<SnackbarContent
				aria-describedby="message-id"
				style={{ backgroundColor: red[700], color: 'black' }}
				message={
					<span style={{ display: 'flex', alignItems: 'center' }} id="message-id">
						<Error style={{ fontSize: 20, opacity: 0.9, marginRight: 6 }} />
						<DynamicFormattedMessage
							id="ServiceStatus.Disconnected"
							defaultMessage="{service} disconnected!"
							values={{ service }}
						/>
					</span>
				}
				action={[
					<IconButton key="close" aria-label="close" color="inherit" onClick={onClose} size="large">
						<CloseIcon style={{ fontSize: 20, opacity: 0.9, marginRight: 6 }} />
					</IconButton>
				]}
			/>
		</Snackbar>
	);
}

ServiceStatusNotification.propTypes = {
	service: PropTypes.string,
	status: PropTypes.string
};

ServiceStatusNotification.defaultProps = { service: 'App-Service', status: 'connected' };

export default withUser(({ serviceStatus }) => ({ ...serviceStatus }))(ServiceStatusNotification);
